<template>
  <div class="container-fluid navigation-bar p-1 px-2">
    <div v-if="!isSelectRequestPage && $store.getters.getSelectedWallet && userChecker && isLargeScreen" class="balance-info">
      <!--      <span>Acc Bal: {{ balance }}</span>-->
      <button class="button" :style="buttonStyle">
        <span>Bal: K{{ balance }}</span>
      </button>
    </div>
    <button @click="syncData" class="reload-button">
      <font-awesome-icon icon="fa-solid fa-arrows-rotate"/>
    </button>

    <!--    <div>-->
    <!--      <button @click="toggle" class="burger">-->
    <!--        <font-awesome-icon icon="fa-solid fa-bars"/>-->
    <!--      </button>-->
    <!--      <h1 class="title">-->
    <!--        {{ pageTitle }}-->
    <!--      </h1>-->
    <!--    </div>-->
    <button @click="toggle" class="burger">
      <font-awesome-icon icon="fa-solid fa-bars"/>
    </button>

    <h1 class="title">
      {{ pageTitle }}
    </h1>

    <div class="navbar-logo"></div>
    <div class="navigation-box"></div>

    <div class="user-settings"></div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "NavigationBar",
  props: {
    toggle: {
      type: Function,
      required: true
    },
    walletAmount: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.checker();
  },
  computed: {
    pageTitle() {
      return this.$route.meta.title || "An error occurred!";
    },
    buttonStyle() {
      return {
        background: this.getGradientColor(this.balance),
        transition: "background 0.3s ease"
      };
    },
    curUser() {
      return this.$store.getters.getCurrentUser;
    },
    currentSelectedWallet() {
      return this.$store.getters.getSelectedWallet;
    },
    isSelectRequestPage() {
      return this.$route.name === 'SelectRequest';
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  watch: {
    currentSelectedWallet(newVal, oldVal) {
      if (newVal) {
        this.fetchBalance();
      }
    }
  },
  data() {
    return {
      verify: '',
      selectedWallet: '',
      balance: 0,
      userChecker: false,
      isLargeScreen: window.innerWidth > 768,
    };
  },
  methods: {
    checkScreenSize() {
      this.isLargeScreen = window.innerWidth > 768; // Adjust breakpoint as needed
    },
    getGradientColor(balance) {
      // Normalize balance between 0 and 1 for color interpolation
      let ratio = Math.max(0, Math.min(1, balance / 100000));

      // Interpolate between green (#90EE90) and pale red (#FFC0C0)
      let r = Math.round(144 * ratio + 255 * (1 - ratio)); // Green to Red
      let g = Math.round(238 * ratio + 192 * (1 - ratio)); // Green to Pale Red
      let b = Math.round(144 * ratio + 192 * (1 - ratio)); // Keep it soft

      return `rgb(${r}, ${g}, ${b})`;
    },
    verifier() {
      this.verify = this.$store.getters.getCurrentUser;
      console.log(this.verify);
      alert('Hello World!');
    },
    checker() {
      this.userChecker = this.curUser.username === "Chris";
      // this.userChecker = this.curUser.username === "Bwezani";
      console.log(this.curUser);
    },
    async fetchBalance() {
      try {
        const selectedWallet = this.currentSelectedWallet;
        if (!selectedWallet) return;
        this.$utils.showLoading();
        const response = await axios.get(`${ticketApi2}transaction-handler/getWalletBalance/${selectedWallet}`);
        this.balance = response.data; // Adjust based on actual response structure
      } catch (error) {
        return errorHandler.tomcatError(error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    async getwallets() {
      this.$utils.showLoading();
      try {
        const response = await axios.get(`${ticketApi2}get-all-wallets`);
        this.wallets = response.data;
        console.log('Wallets2:', this.wallets);

        if (this.wallets.length > 0) {
          this.selectedWallet = this.wallets[0].id;
        }
      } catch (error) {
        return errorHandler.tomcatError(error);
      } finally {
        this.$utils.hideLoading();
      }
    },
    syncData() {
      this.$utils.showLoading();
      return window.location.reload(true);
    }
  },
  beforeMount() {
    this.fetchBalance();
    this.getwallets();
    window.removeEventListener("resize", this.checkScreenSize);
  },
};
</script>

<style scoped>
.title {
  font-weight: 300;
  font-size: 30px;
  color: aliceblue;
  margin-top: 5px;

}
.navigation-bar {
  position: relative;
  background: #3F8DCD;
  height: 60px;
}

.reload-button {
  position: absolute;
  right: 0;
  top: 40%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: white;
  font-size: 30px;
}

.burger {
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: white;
  font-size: 30px;
}

.balance-info {
  position: absolute;
  right: 60px; /* Adjust spacing as needed */
  top: 50%;
  transform: translateY(-50%);
  color: white;
  font-size: 16px; /* Adjust font size as needed */
  font-weight: bold;
}

.user-settings {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center; /* Center align items */
}

.page {
  background: linear-gradient(0deg, #15356E 0%, #3F8DCD 100%) !important;
  overflow: hidden;
}

::selection {
  background: linear-gradient(0deg, #15356E 0%, #3F8DCD 100%) !important;
}

.button {
  background-color: white;
  color: dimgray;
  border-radius: 5px;
  font-size: 17px;
  font-weight: 600;
  padding: 8px 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border: 1px solid black;
  box-shadow: 0 0 0 0 black;
}

.button:hover {
  transform: translateY(-4px) translateX(-2px);
  box-shadow: 2px 5px 0 0 black;
}

button:active {
  transform: translateY(2px) translateX(1px);
  box-shadow: 0 0 0 0 black;
}
</style>
